import { c as _c } from "react/compiler-runtime";
import { Button, useToast } from "@flat-ui";
import { useMembersUtils } from "@hooks/use-member-utils";
import { Box, Grid } from "@mui-wrapper";
import { TEAM_DISPLAY_NAME } from "@src/constants/team-constants";
import { FaroCoreApiUtils } from "@stellar/core-api-client";
import { capitalizeFirstLetter } from "@utils/string-utils";
/**
 * Component that shows the button to open the profile page of the user.
 */
export function UserMoreInfoMenuProfileButton(t0) {
  const $ = _c(16);
  const {
    member
  } = t0;
  const {
    openProfilePage,
    openViewTeamMembers
  } = useMembersUtils();
  const {
    openToast
  } = useToast();
  if (!member) {
    return null;
  }
  let t1;
  if ($[0] !== member) {
    t1 = FaroCoreApiUtils.Member.isTeam(member);
    $[0] = member;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isBelongsToTeam = t1;
  let t2;
  if ($[2] !== isBelongsToTeam || $[3] !== member || $[4] !== openProfilePage || $[5] !== openToast || $[6] !== openViewTeamMembers) {
    t2 = function openProfileOrTeamMembersClick(event) {
      event.stopPropagation();
      if (isBelongsToTeam) {
        if (member?.id) {
          openViewTeamMembers({
            teamId: member.id
          });
        } else {
          openToast({
            title: `${capitalizeFirstLetter(TEAM_DISPLAY_NAME)} profile page cannot be opened`,
            message: `The ${TEAM_DISPLAY_NAME} ID is not available. Please reload the page to try again.`,
            variant: "error"
          });
        }
      } else {
        openProfilePage({
          member,
          source: "user more info menu"
        });
      }
    };
    $[2] = isBelongsToTeam;
    $[3] = member;
    $[4] = openProfilePage;
    $[5] = openToast;
    $[6] = openViewTeamMembers;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const openProfileOrTeamMembersClick = t2;
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      padding: "10px"
    };
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      color: "text.primary",
      fontSize: "14px",
      width: "100%",
      height: "37px",
      backgroundColor: "background.paper",
      border: "none",
      textAlign: "left",
      textTransform: "none",
      "&:hover": {
        backgroundColor: "action.hover"
      },
      "&:active": {
        backgroundColor: "action.selected"
      },
      "&:hover,:active": {
        color: "primary.main",
        cursor: "pointer"
      }
    };
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      textAlign: "start"
    };
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const t6 = isBelongsToTeam ? "View members" : "Profile";
  let t7;
  if ($[11] !== t6) {
    t7 = <Grid container={true} sx={t5}>{t6}</Grid>;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== openProfileOrTeamMembersClick || $[14] !== t7) {
    t8 = <Box component="div" sx={t3}><Button variant="ghost" disableFocusRipple={true} disableRipple={true} draggable={false} sx={t4} onClick={openProfileOrTeamMembersClick}>{t7}</Button></Box>;
    $[13] = openProfileOrTeamMembersClick;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
}